/**
 * Timeout (in milliseconds) for smooth scrolling animations
 */
export const SCROLL_ANIMATION_TIMEOUT_MS = 2000;

/**
 * Timeout (in milliseconds) for the collapse expand/shrink animations
 */
export const COLLAPSE_ANIMATION_TIMEOUT_MS = 2000;
